<template>
  <div class="me-container">
    <el-row :gutter="20">
      <el-col :md="10" :sm="24">
        <el-card class="user-card" shadow="hover">
          <div class="user-profile">
            <el-avatar :size="80" :src="user ? user.avatarUrl : ''" class="avatar" />
            <div class="user-info">
              <div class="username">
                {{ user ? user.name : '未登录' }}
                <el-tag size="mini" type="warning" effect="dark" round>黄金VIP</el-tag>
              </div>
              <div class="user-id">ID: {{ user ? user.userId : '-' }}</div>
              <el-button type="text" size="small" icon="el-icon-edit">修改资料</el-button>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :md="14" :sm="24">
        <el-card class="storage-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="title">存储空间</span>
            <el-button type="text">扩容套餐</el-button>
          </div>

          <div class="usage-summary">
            <span class="used">{{ usedSpaceGB }} GB</span>
            <span class="total">/ {{ totalSpaceGB }} GB</span>
          </div>

          <div class="multi-progress-bar">
            <div class="segment video" :style="{ width: videoPercent + '%' }" title="视频" />
            <div class="segment photo" :style="{ width: photoPercent + '%' }" title="照片" />
            <div class="segment other" :style="{ width: otherPercent + '%' }" title="其他" />
          </div>

          <div class="legend">
            <div class="legend-item"><i class="dot video" />视频 ({{ videoPercent }}%)</div>
            <div class="legend-item"><i class="dot photo" />照片 ({{ photoPercent }}%)</div>
            <div class="legend-item"><i class="dot other" />其他 ({{ otherPercent }}%)</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="action-grid">
      <el-col v-for="item in actionList" :key="item.title" :md="8" :sm="12">
        <el-card class="action-card" shadow="hover" @click.native="handleAction(item)">
          <div class="action-inner">
            <i :class="item.icon" :style="{ color: item.color }" />
            <div class="action-text">
              <div class="action-title">{{ item.title }}</div>
              <div class="action-desc">{{ item.desc }}</div>
            </div>
            <i class="el-icon-arrow-right arrow" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      title="账号设置"
      :visible.sync="showSettings"
      width="450px"
      append-to-body
      custom-class="pikpak-dialog"
    >
      <el-form label-position="left" label-width="120px">
        <el-form-item label="离线下载通知">
          <el-switch v-model="switchEnabled" @change="onSwitchChange" />
        </el-form-item>
        <el-form-item label="隐私保护模式">
          <el-switch v-model="privacyEnabled" />
        </el-form-item>
        <el-form-item label="客户端版本">
          <span class="version-text">v1.2.0 (Stable)</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" round class="save-btn" @click="showSettings = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 假设你有一个提交状态的接口
import { submitActivity } from '@/api/disk'

export default {
  name: 'DiskMe',
  data() {
    return {
      user: null,
      usedSpaceGB: 120,
      totalSpaceGB: 6144, // 6TB
      videoPercent: 45,
      photoPercent: 15,
      otherPercent: 10,
      showSettings: false,
      switchEnabled: false,
      privacyEnabled: true,
      actionList: [
        { title: '离线下载', desc: '支持磁力链接与 BT 种子', icon: 'el-icon-link', color: '#1989fa' },
        { title: '回收站', desc: '已删除文件保留 30 天', icon: 'el-icon-delete', color: '#f56c6c' },
        { title: '传输中心', desc: '查看当前上传与下载任务', icon: 'el-icon-sort', color: '#67c23a' },
        { title: '个人设置', desc: '修改头像、密码与偏好', icon: 'el-icon-setting', color: '#909399', action: 'settings' },
        { title: '帮助反馈', desc: '遇到问题？联系我们的客服', icon: 'el-icon-chat-dot-round', color: '#e6a23c' }
      ]
    }
  },
  created() {
    this.user = this.$store.state.userInfo
  },
  methods: {
    handleAction(item) {
      if (item.action === 'settings') {
        this.showSettings = true
      } else {
        this.$message.info(`跳转到: ${item.title}`)
      }
    },
    onSwitchChange(val) {
      submitActivity({ enabled: val }).then(resp => {
        if (resp.code === 0) {
          this.$message.success('设置更新成功')
        }
      })
    }
  }
}
</script>

<style scoped>
.me-container {
  padding: 10px;

  /* 用户卡片 */
  .user-card {
    border-radius: 16px;
    height: 200px;
    display: flex;
    align-items: center;

    .user-profile {
      display: flex;
      align-items: center;
      padding: 10px;

      .user-info {
        margin-left: 24px;
        .username {
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .user-id {
          color: #909399;
          font-size: 14px;
          margin-bottom: 10px;
        }
      }
    }
  }

  /* 存储卡片 */
  .storage-card {
    border-radius: 16px;
    height: 200px;

    .card-header {
      display: flex;
      justify-content: space-between;
      .title { font-weight: bold; }
    }

    .usage-summary {
      margin-bottom: 15px;
      .used { font-size: 28px; font-weight: bold; color: #1a73e8; }
      .total { font-size: 16px; color: #909399; margin-left: 5px; }
    }

    .multi-progress-bar {
      height: 10px;
      background: #f0f2f5;
      border-radius: 5px;
      display: flex;
      overflow: hidden;
      margin-bottom: 15px;

      .segment {
        height: 100%;
        transition: width 0.4s ease;
        &.video { background: #1989fa; }
        &.photo { background: #67c23a; }
        &.other { background: #ff976a; }
      }
    }

    .legend {
      display: flex;
      gap: 20px;
      .legend-item {
        font-size: 12px;
        color: #606266;
        display: flex;
        align-items: center;
        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 6px;
          &.video { background: #1989fa; }
          &.photo { background: #67c23a; }
          &.other { background: #ff976a; }
        }
      }
    }
  }

  /* 功能卡片网格 */
  .action-grid {
    margin-top: 20px;

    .action-card {
      margin-bottom: 20px;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.08);
      }

      .action-inner {
        display: flex;
        align-items: center;
        padding: 10px;

        i:first-child {
          font-size: 32px;
          margin-right: 20px;
        }

        .action-text {
          flex-grow: 1;
          .action-title { font-weight: bold; font-size: 15px; margin-bottom: 4px; }
          .action-desc { font-size: 12px; color: #909399; }
        }

        .arrow { color: #dcdfe6; }
      }
    }
  }
}

/* 弹窗样式 */
::v-deep .pikpak-dialog {
  border-radius: 20px;
  .el-dialog__header { padding: 25px 25px 10px; }
  .el-dialog__title { font-weight: bold; }
  .save-btn { width: 100%; margin-top: 10px; }
  .version-text { color: #909399; font-family: monospace; }
}
</style>
